////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { cloneDeep, isUndefined } from 'lodash'
import moment from 'moment'
import { useSelector, shallowEqual } from 'react-redux'
///////COMPONENTS///////
import DatePicker from '../../components/CalendarInputInline/DateTimePicker'
import Modals from '../../components/Modals/'

const UseDatePicker = (props) => {
	const [showModal, setShowModal] = useState(false)
	const [startDate, setStartDate] = useState()
	const [endDate, setEndDate] = useState()
	const [timeTouch, setTimeTouch] = useState(false)
	const [windowPageYOffset, setWindowPageYOffset] = useState(0)
	const [windowPageXOffset, setWindowPageXOffset] = useState(0)
	const [noTime, setNoTime] = useState(false)
	const [stateDate, setStateDate] = useState({
		date: {
			startDate: startDate,
			endDate: endDate,
			timeTouch: timeTouch,
		},
		showModal: showModal,
		windowPageYOffset: windowPageYOffset,
		windowPageXOffset: windowPageXOffset,
	})
	const [titleDatePicker, setTitleDatePicker] = useState('')

	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			datePicker: state.user.datePicker,
		}),
		shallowEqual
	)

	const [defaultDateState, setDefaultDateState] = useState({
		date: {
			startDate: {},
			endDate: {},
			timeTouch: false,
		},
		showModal: false,
		windowPageYOffset: 0,
		windowPageXOffset: 0,
	})
	///////////////////////////////// HANDLE ///////////////////////////////////////

	const startDateHandleChange = (date) => {
		const prevState = cloneDeep(stateDate)
		// check if time was set by user
		// if not put midnight by default
		if (prevState.date.timeTouch) {
			setStartDate(moment(date).toDate())
		} else if (props?.noPastDate) {
			setStartDate(moment(date).startOf('day').toDate())
		} else {
			setStartDate(moment(date).startOf('day').toDate())
		}
	}

	const endDateHandleChange = (date) => {
		const prevState = cloneDeep(stateDate)
		// check if time was set by user
		// if not put midnight by default
		if (prevState.date.timeTouch) {
			setEndDate(new Date(date))
		} else {
			setEndDate(moment(date).endOf('day').minute('59').toDate())
		}
	}

	const startTimeHandleChange = (date) => {
		setStartDate(moment(date).toDate())
		setTimeTouch(true)
	}

	const endTimeHandleChange = (date) => {
		setEndDate(date)
		setTimeTouch(true)
	}

	const openDateModalHandler = () => {
		setShowModal(true)
		setWindowPageYOffset(window.pageYOffset)
		setWindowPageXOffset(window.pageXOffset)

		window.addEventListener('scroll', onScrollHandler)
	}

	const closeDateModalHandler = () => {
		setShowModal(false)

		window.removeEventListener('scroll', onScrollHandler)
	}

	const onScrollHandler = () => {
		if (showModal) {
			window.scrollTo(windowPageXOffset, windowPageYOffset)
		}
	}

	const getDateFormatToLayout = (date) => {
		return moment(date).format('DD-MM-YYYY')
	}

	const updateDate = () => {
		const { date } = cloneDeep(stateDate)
		// Action need to be variable, we could have multiple use for a datepicker
		//const { actionsDatePicker } = this.props

		//this.defaultState.date = date
		defaultDateState.date = date
		const updateStore = {
			startDate: date.startDate,
			endDate: date.endDate,
		}

		if (!isUndefined(props) && !isUndefined(props.actionUpdate)) props.actionUpdate(updateStore)

		// Action need to be variable, we could have multiple use for a datepicker
		//actionsDatePicker.updateDate(updateStore);
		closeDateModalHandler()
	}

	const onClickToDayHandler = () => {
		setStartDate(moment().startOf('day').toDate())
		setEndDate(moment().endOf('day').minute(59).toDate())
	}

	const onClickOneWeekHandler = () => {
		setStartDate(moment().subtract(7, 'days').startOf('day').toDate())
		setEndDate(moment().endOf('day').minute(59).toDate())
	}

	const onClickOneMonthHandler = () => {
		setStartDate(moment().subtract(1, 'months').startOf('day').toDate())
		setEndDate(moment().endOf('day').minute(59).toDate())
	}

	const cancelUpdateHandler = () => {
		setStateDate(defaultDateState)
		setStartDate(defaultDateState.date.startDate)
		setEndDate(defaultDateState.date.endDate)
		setShowModal(false)
	}

	const renderModal = () => {
		return (
			<Modals
				title={titleDatePicker}
				closeModalHandler={closeDateModalHandler}
				showModal={showModal}
				insideModal={props?.insideModal ? true : false}
			>
				{!isUndefined(noTime) ? (
					<DatePicker
						toDayHandler={onClickToDayHandler}
						weekSelectHandler={onClickOneWeekHandler}
						monthSelectHandler={onClickOneMonthHandler}
						closeModalHandler={closeDateModalHandler}
						startDate={startDate}
						endDate={endDate}
						startDateHandleChange={startDateHandleChange}
						endDateHandleChange={endDateHandleChange}
						startTimeHandleChange={startTimeHandleChange}
						endTimeHandleChange={endTimeHandleChange}
						formatDate={getDateFormatToLayout}
						updateDate={updateDate}
						cancelUpdateHandler={cancelUpdateHandler}
						translations={translations}
						noInterval={props?.noInterval} // If no interval, no min and max date
						noPastDate={props?.noPastDate} // But if this is true, no date before today
						disableStartDate={props?.disableStartDate}
						disableEndDate={props?.disableEndDate}
						noTime={!isUndefined(props?.noTime) ? props.noTime : false}
						priorStartLimit={props?.priorStartLimit}
						priorEndLimit={props?.priorEndLimit}
					/>
				) : (
					isUndefined(noTime) && (
						<DatePicker
							toDayHandler={onClickToDayHandler}
							weekSelectHandler={onClickOneWeekHandler}
							monthSelectHandler={onClickOneMonthHandler}
							closeModalHandler={closeDateModalHandler}
							startDate={startDate}
							endDate={endDate}
							startDateHandleChange={startDateHandleChange}
							endDateHandleChange={endDateHandleChange}
							startTimeHandleChange={startTimeHandleChange}
							endTimeHandleChange={endTimeHandleChange}
							formatDate={getDateFormatToLayout}
							updateDate={updateDate}
							cancelUpdateHandler={cancelUpdateHandler}
							translations={translations}
							noInterval={props?.noInterval} // If no interval, no min and max date
							noPastDate={props?.noPastDate} // But if this is true, no date before today
							disableStartDate={props?.disableStartDate}
							disableEndDate={props?.disableEndDate}
							priorStartLimit={props?.priorStartLimit}
							priorEndLimit={props?.priorEndLimit}
						/>
					)
				)}
			</Modals>
		)
	}
	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		setStateDate({
			date: {
				startDate: startDate,
				endDate: endDate,
				timeTouch: timeTouch,
			},
			showModal: showModal,
			windowPageYOffset: windowPageYOffset,
			windowPageXOffset: windowPageXOffset,
		})
	}, [startDate, endDate, timeTouch, windowPageXOffset, windowPageYOffset, showModal])

	useEffect(() => {
		let inputDateStart
		let inputDateEnd
		if (props?.defaultDateStart || props?.defaultDateEnd) {
			inputDateStart = props.defaultDateStart
			inputDateEnd = props.defaultDateEnd
		} else {
			inputDateStart = moment(new Date()).subtract(2, 'weeks').toDate()
			inputDateEnd = moment(new Date()).toDate()
		}
		setStartDate(inputDateStart)
		setEndDate(inputDateEnd)
		setDefaultDateState({
			date: {
				startDate: inputDateStart,
				endDate: inputDateEnd,
				timeTouch: false,
			},
			showModal: false,
			windowPageYOffset: 0,
			windowPageXOffset: 0,
		})
	}, [])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return [showModal, openDateModalHandler, renderModal, stateDate, setStartDate, setEndDate]
}

UseDatePicker.propTypes = {}

UseDatePicker.defaultPropTypes = {}

export default UseDatePicker
